import { Component } from '@angular/core';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridProgramSharedComponent } from '@unity/shared/grid-program-shared/grid-program-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-program-page',
  standalone: true,
  imports: [PageContainerComponent, GridProgramSharedComponent, ActionSharedComponent],
  templateUrl: './list-program-page.component.html',
  styleUrl: './list-program-page.component.scss',
})
export class ListProgramPageComponent {
  protected createProgramAction = QuickActions.CreateProgram;
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
